import { render } from "./DownloadStep.vue?vue&type=template&id=3afaea79&ts=true"
import script from "./DownloadStep.vue?vue&type=script&lang=ts"
export * from "./DownloadStep.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__